import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { initializeTab, isCurrentTabLoggedIn, getCurrentTabRole } from '../Slice/AuthSlice';

export function ProtectedOutlet() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isCurrentTabLoggedIn);
  const legacyIsLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  // Initialize tab if not already done
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentTabId = sessionStorage.getItem('current_tab_id');
      if (!currentTabId) {
        dispatch(initializeTab({}));
      }
    }
  }, [dispatch]);

  // Use multi-tab auth or fallback to legacy auth
  const authenticated = isLoggedIn || legacyIsLoggedIn;

  if (authenticated) {
    return <Outlet />;
  } else {
    return <Navigate to="/" />;
  }
}

export function PublicOutlet() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isCurrentTabLoggedIn);
  const role = useSelector(getCurrentTabRole);
  const currentTabAuth = useSelector((state) => {
    const currentTabId = state.auth.currentTabId;
    return currentTabId ? state.auth.tabs[currentTabId] : null;
  });

  // Fallback to legacy auth
  const legacyAuth = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
    role: state.auth.role,
    justRegistered: state.auth.justRegistered,
  }));

  // Initialize tab if not already done
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentTabId = sessionStorage.getItem('current_tab_id');
      if (!currentTabId) {
        dispatch(initializeTab({}));
      }
    }
  }, [dispatch]);

  // Use multi-tab auth or fallback to legacy
  const authenticated = isLoggedIn || legacyAuth.isLoggedIn;
  const userRole = role || legacyAuth.role;
  const justRegistered = currentTabAuth?.justRegistered || legacyAuth.justRegistered;

  if (authenticated) {
    if (justRegistered === true && userRole === 'client') {
      // After register → always show subscriptions
      return <Navigate to="/subscriptions" replace />;
    }
    // Redirect based on role normal login flow
    const dashboard = userRole === 'admin' ? '/admin/dashboard' : '/dashboard';
    return <Navigate to={dashboard} replace />;
  }
  return <Outlet />;
}
